import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidateFieldsService } from '../../services/validate-fields.service';

@Component({
  selector: 'app-error-field',
  templateUrl: './error-field.component.html',
  styleUrls: ['./error-field.component.scss']
})
export class ErrorFieldComponent implements OnInit {

  @Input() control: AbstractControl;

  constructor(public validate: ValidateFieldsService) { }

  ngOnInit(): void {
  }

}
